<script setup>
import TableRow from "@/components/global-themed/table/TableRow.vue";
import HintSquare from "@/components/global-themed/HintSquare.vue";
import CompetitorCell from "@/components/competition/partials/compare/CompetitorCell.vue";
import TableCell from "@/components/global-themed/table/TableCell.vue";
import TableBody from "@/components/global-themed/table/TableBody.vue";
import {computed} from "vue";
import {useStore} from "vuex";

const store = useStore();
const websiteCompareData = computed(() => store.getters['competitionV2/websiteCompareData']);
const compareCompetitorColumns = computed(() => store.getters["competitionV2/compareCompetitorColumns"]);
</script>

<template>
  <TableBody>
    <TableRow>
      <TableCell
        col-span="2"
        class="tw-flex tw-items-center tw-gap-2"
      >
        <span>Position 1 Keywords</span>
        <HintSquare hint="Number of keywords in position 1 in Google" />
      </TableCell>

      <TableCell
        col-span="2"
        class="tw-font-medium tw-text-center"
      >
        {{ websiteCompareData?.pos1?.toLocaleString() ?? 'N/A' }}
      </TableCell>

      <CompetitorCell
        v-for="column in compareCompetitorColumns"
        :key="column"
        name="pos1"
        :column="column"
      />
    </TableRow>

    <TableRow>
      <TableCell
        col-span="2"
        class="tw-flex tw-items-center tw-gap-2"
      >
        <span>Position 1-3 Keywords</span>
        <HintSquare hint="Number of keywords in the top 3 positions in Google" />
      </TableCell>

      <TableCell
        col-span="2"
        class="tw-font-medium tw-text-center"
      >
        {{ websiteCompareData?.top3?.toLocaleString() ?? 'N/A' }}
      </TableCell>

      <CompetitorCell
        v-for="column in compareCompetitorColumns"
        :key="column"
        name="top3"
        :column="column"
      />
    </TableRow>

    <TableRow>
      <TableCell
        col-span="2"
        class="tw-flex tw-items-center tw-gap-2"
      >
        <span>Page 1 Keywords</span>
        <HintSquare hint="Number of keywords on page 1 in Google" />
      </TableCell>

      <TableCell
        col-span="2"
        class="tw-font-medium tw-text-center"
      >
        {{ websiteCompareData?.page1?.toLocaleString() ?? 'N/A' }}
      </TableCell>

      <CompetitorCell
        v-for="column in compareCompetitorColumns"
        :key="column"
        name="page1"
        :column="column"
      />
    </TableRow>

    <TableRow>
      <TableCell
        col-span="2"
        class="tw-flex tw-items-center tw-gap-2"
      >
        <span>Page 2 Keywords</span>
        <HintSquare hint="Number of keywords on page 2 in Google" />
      </TableCell>

      <TableCell
        col-span="2"
        class="tw-font-medium tw-text-center"
      >
        {{ websiteCompareData?.page2?.toLocaleString() ?? 'N/A' }}
      </TableCell>

      <CompetitorCell
        v-for="column in compareCompetitorColumns"
        :key="column"
        name="page2"
        :column="column"
      />
    </TableRow>

    <TableRow>
      <TableCell
        col-span="2"
        class="tw-flex tw-items-center tw-gap-2"
      >
        <span>Total Keywords</span>
        <HintSquare hint="The total number of keywords found in Google’s top ten pages" />
      </TableCell>

      <TableCell
        col-span="2"
        class="tw-font-medium tw-text-center"
      >
        {{ websiteCompareData?.totalKeywords?.toLocaleString() ?? 'N/A' }}
      </TableCell>

      <CompetitorCell
        v-for="column in compareCompetitorColumns"
        :key="column"
        name="totalKeywords"
        :column="column"
      />
    </TableRow>
  </TableBody>
</template>